module.exports = __webpack_public_path__ + "img/arrow-down-short.204f446d.svg";